"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyDoTDamageV2 = void 0;
const __1 = require("../..");
const Damage_1 = require("../Damage");
const Duration_1 = require("../Duration");
const enums_1 = require("../enums");
const Calculators_1 = require("../state/Calculators");
function applyDoTDamageV2(args) {
    var _a;
    if (this.isDeceased(args.targetId)) {
        return;
    }
    const { attackerId, targetId, damage } = args;
    let { sequence } = args;
    const [critChance] = this.getAttributeScores(attackerId, [
        enums_1.AttributeType.CriticalStrikeChance,
    ]);
    const { didCrit } = (0, Calculators_1.testCrit)(critChance);
    const defensiveAttr = damage.primaryAttribute === "Focus" ? enums_1.AttributeType.Will
        : enums_1.AttributeType.Toughness;
    const effect = __1.DamageEffectArgs.fromDoT(this, damage.effectType, enums_1.DamageType[damage.type], attackerId, targetId, enums_1.AttributeType[damage.primaryAttribute], defensiveAttr, damage.power, didCrit);
    if (effect.damage.amount === 0) {
        return {
            damage: effect.damage
        };
    }
    const damageId = this.applyEffect(sequence, attackerId, targetId, effect, Duration_1.Duration.Instant);
    return {
        damage: (_a = this.getEffect(damageId).args.damage) !== null && _a !== void 0 ? _a : Damage_1.Damage.None
    };
}
exports.applyDoTDamageV2 = applyDoTDamageV2;
